import * as React from 'react';

function SvgTagIcon(props) {
  return (
    <svg viewBox="0 0 41 41" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none">
        <path d="M-3-5h48v48H-3z" />
        <path
          d="M26.128 6.293L15.154 9.234a3 3 0 00-1.822 1.398L3.5 27.662a3 3 0 001.098 4.097l13.915 8.034a3 3 0 004.098-1.098l9.832-17.03a3 3 0 00.3-2.276l-2.94-10.974a3 3 0 00-3.675-2.122z"
          fill="#FCCE01"
        />
        <path
          d="M31.49 9.423a15.84 15.84 0 001.743-.492c4.091-1.408 6.776-4.147 6.17-5.909-.559-1.62-3.866-2.202-7.66-1.122a.6.6 0 11-.33-1.154c4.332-1.233 8.29-.537 9.124 1.885.896 2.603-2.276 5.838-6.913 7.435-.613.21-1.223.384-1.823.518l1.094 4.083a3.9 3.9 0 01-.39 2.96l-10.45 18.1a2.9 2.9 0 01-3.961 1.06L2.258 27.646a2.9 2.9 0 01-1.062-3.962l10.45-18.1a3.9 3.9 0 012.368-1.817l12.09-3.24a2.9 2.9 0 013.551 2.051l1.835 6.846zm-1.79.278l-1.783-6.658a1.1 1.1 0 00-1.347-.777L14.48 5.505a2.1 2.1 0 00-1.275.978l-10.45 18.1a1.1 1.1 0 00.403 1.503l15.836 9.143a1.1 1.1 0 001.502-.403l10.45-18.1a2.1 2.1 0 00.21-1.593l-1.14-4.255c-3.166.325-5.76-.505-6.417-2.414a.6.6 0 011.134-.391c.425 1.232 2.412 1.85 4.968 1.628zm-2.666-2.45a.9.9 0 01-1.74.466A1.421 1.421 0 1023.187 9.3a.9.9 0 11-.931 1.54 3.221 3.221 0 114.779-3.59zM15.68 16.695a.9.9 0 11.9-1.559l8.846 5.107a.9.9 0 01-.9 1.56l-8.846-5.108zm2.164 5.538a.9.9 0 01.9-1.559l4.825 2.786a.9.9 0 01-.9 1.559l-4.825-2.786zm-3.466 2.288a.9.9 0 11.9-1.559l6.434 3.715a.9.9 0 11-.9 1.558l-6.434-3.714z"
          fill="#4D4E4C"
        />
      </g>
    </svg>
  );
}

export default SvgTagIcon;
